import React from 'react';
import FeatureCard from '../../Common/Cards/FeatureCard';
import './CustomAppointmentCard.scss';

export default function CustomAppointmentCard(props) {
    return (
        <div className="feature-detail">
            <div>
                <h6 className="text-center mt-2"><b>{props.title}</b></h6>
            </div>
            <ul>
                {props.data.map((item, index) => <FeatureCard planFeature={item} key={index} />)}
            </ul>
        </div>
    )
}